import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { compact, map } from 'lodash'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import classNames from 'classnames'

import css from './store-breadcrumb.scss'
import { getCategoryBySlug } from 'store/reducers'
import * as blUrls from 'lib/urls'
import { useTracking } from 'lib/analytics'
import { trackBreadcrumbLinkClick } from 'src/routes/(shop)/lib/tracking'

export class StoreBreadcrumb extends PureComponent {
  static propTypes = {
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        urlSlug: PropTypes.string.isRequired,
      })
    ),
    className: PropTypes.string,
    product: PropTypes.shape({
      title: PropTypes.string,
      name: PropTypes.string,
      path: PropTypes.string,
    }),
  }

  static defaultProps = {
    categories: [],
  }

  render() {
    return (
      <div className={classNames(css.breadcrumbs, this.props.className)}>
        {this.props.categories && this.props.categories.length > 0 ? (
          <span>
            <Crumb
              first
              to={{ pathname: blUrls.storePath, state: { slugSet: [] } }}
              text="Home"
            />
            {map(this.props.categories, (category, idx) => {
              if (category.hidden) return null
              return (
                <Crumb
                  key={category.urlSlug}
                  to={{
                    pathname: blUrls.storeCategoryPath(category.urlSlug),
                    state: { slugSet: this.slugSetForIndex(idx) },
                  }}
                  text={category.title}
                />
              )
            })}
            {this.props.product ? (
              <Crumb
                to={{
                  pathname: this.props.product.path,
                  state: { slugSet: this.slugSet() },
                }}
                text={this.props.product.name}
              />
            ) : null}
          </span>
        ) : null}
      </div>
    )
  }

  slugSet() {
    return map(this.props.categories, 'urlSlug')
  }

  slugSetForIndex(idx) {
    return this.slugSet().slice(0, idx + 1)
  }
}

const Crumb = ({ to, text, first }) => {
  const { trackEvent } = useTracking()

  return (
    <span>
      {!first ? ' / ' : null}
      <Link
        className="link-body-text"
        to={to}
        onClick={() => trackBreadcrumbLinkClick(trackEvent)}
      >
        {text}
      </Link>
    </span>
  )
}

Crumb.propTypes = {
  first: PropTypes.bool,
  text: PropTypes.string,
  to: PropTypes.object,
}

const mapStateToProps = (state, ownProps) => {
  return {
    categories: compact(
      map(ownProps.activeSlugSet, (slug) => getCategoryBySlug(state, slug))
    ),
  }
}

export default connect(mapStateToProps)(StoreBreadcrumb)
